import React from 'react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  text?: string;
  fullScreen?: boolean;
  variant?: 'spinner' | 'dots' | 'ring' | 'ball' | 'bars';
}

export default function LoadingSpinner({
  size = 'lg',
  text,
  fullScreen = true,
  variant = 'spinner'
}: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'loading-sm',
    md: 'loading-md',
    lg: 'loading-lg'
  };

  const variantClasses = {
    spinner: 'loading-spinner',
    dots: 'loading-dots',
    ring: 'loading-ring',
    ball: 'loading-ball',
    bars: 'loading-bars'
  };

  const content = (
    <div className="flex flex-col items-center justify-center gap-4">
      <span className={`loading ${variantClasses[variant]} ${sizeClasses[size]} text-primary`}></span>
      {text && <p className="text-primary font-medium">{text}</p>}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        {content}
      </div>
    );
  }

  return content;
}

